<template>
  <div class="Wait">
    <div class="Con">
      <img src="../../../../static/img/logo_cover.png" width="80%">
      <div>
        <label class="AppText">您的申请正在审核中...</label>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  name: 'Wait',
  data() {
    return {
    }
  }
}
</script>

<style scoped>
.Wait{
  position: absolute;
  left: 0;
  top: calc(50% - 56px);
  visibility: visible;
  opacity: 1;
  bottom: 0;
  right: 0;
  text-align: center;
}
.Con{
  object-fit:contain;
  width:auto;
  height:auto;
  max-width:100%;
  max-height:100%;
  transform:translateY(-50%);
  -ms-transform:translateY(-50%);
  -moz-transform:translateY(-50%);
  -webkit-transform:translateY(-50%);
  -o-transform:translateY(-50%);
}
.AppText {
  color: #30328a;
  line-height: 40px;
  font-size: 18px;
}
</style>



// WEBPACK FOOTER //
// src/view/OnLineBook/components/Wait.vue